<div class="p-6">
  <!-- Header -->
  <div class="mb-4">
    <h2 class="text-2xl font-bold text-slate-800">State Big I Association Members</h2>
    <p class="text-slate-500 text-sm">
      Manage state associations and their membership levels
    </p>
  </div>

  <!-- Filter -->
  <div class="mb-4 flex items-center space-x-2">
    <label for="memberLevel" class="text-slate-600 font-medium">Filter by:</label>
    <div class="relative">
      <select
        id="memberLevel"
        [(ngModel)]="selectedLevel"
        (change)="filterByLevel()"
        class="appearance-none border border-slate-300 rounded-md px-3 py-2 pr-8 text-sm text-slate-700 bg-white focus:outline-none focus:ring-0 focus:ring-transparent focus:border-transparent"
      >
        <option value="">All Member Levels</option>
        <option value="0">Not a Member</option>
        <option value="1">Level 1</option>
        <option value="2">Level 2</option>
        <option value="3">Level 3</option>
      </select>
      <svg
        class="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none text-slate-700"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 12 12"
        fill="currentColor"
      >
        <path d="M6 9L1 4h10z"/>
      </svg>
    </div>
  </div>

  <!-- CDK Table -->
  <div class="overflow-x-auto rounded-lg border border-slate-200 shadow-sm bg-white relative min-h-[200px]">
    <!-- Loading Overlay -->
    <div
      *ngIf="isLoading"
      class="absolute inset-0 bg-white bg-opacity-90 flex flex-col items-center justify-center z-10"
    >
      <div class="w-12 h-12 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin mb-4"></div>
      <p class="text-sm text-gray-600">Loading state associations...</p>
    </div>

    <table
      cdk-table
      [dataSource]="filteredAssociations"
      class="min-w-full text-left text-sm border-separate border-spacing-0"
      [class.opacity-50]="isLoading"
    >
      <!-- State Column -->
      <ng-container cdkColumnDef="state">
        <th
          cdk-header-cell
          *cdkHeaderCellDef
          class="px-6 py-3 bg-white text-slate-600 font-semibold uppercase text-xs tracking-wide"
        >
          State Association
        </th>
        <td
          cdk-cell
          *cdkCellDef="let assoc"
          class="px-6 py-3 font-medium text-momentum-deep_purple hover:underline hover:text-momentum-royal_purple"
        >
          {{ assoc.state }}
        </td>
      </ng-container>

      <!-- Member Level Column -->
      <ng-container cdkColumnDef="memberLevel">
        <th
          cdk-header-cell
          *cdkHeaderCellDef
          class="px-6 py-3 bg-white font-semibold uppercase text-xs tracking-wide"
        >
          Member Level
        </th>
        <td
          cdk-cell
          *cdkCellDef="let assoc"
          class="px-6 py-3"
        >
          <button
            class="inline-flex items-center justify-center border-0 rounded-full cursor-pointer px-5 py-1 text-center overflow-hidden min-h-[20px] max-h-[50px] leading-5 transition-all duration-150 select-none align-middle text-white text-sm min-w-[130px]"
            [ngClass]="getMemberLevelClass(assoc.memberLevel)"
            tabindex="-1"
          >
            {{ getMemberLevelText(assoc.memberLevel) }}
          </button>
        </td>
      </ng-container>

      <!-- Agency Count Column -->
      <ng-container cdkColumnDef="agencyCount">
        <th
          cdk-header-cell
          *cdkHeaderCellDef
          class="px-6 py-3 bg-white text-slate-600 font-semibold uppercase text-xs tracking-wide text-center"
        >
          Number of Agencies
        </th>
        <td
          cdk-cell
          *cdkCellDef="let assoc"
          class="px-6 py-3 text-center text-slate-600 font-medium"
        >
          {{ getAgencyCount(assoc) }}
        </td>
      </ng-container>

      <!-- Header Row -->
      <tr
        cdk-header-row
        *cdkHeaderRowDef="displayedColumns"
        class="shadow-md bg-white"
      ></tr>

      <!-- Data Rows -->
      <tr
        cdk-row
        *cdkRowDef="let assoc; columns: displayedColumns"
        class="border-t first:border-t-0 hover:shadow transition-all duration-150 cursor-pointer hover:bg-agentium_blue-light"
        (click)="navigateToDetail(assoc)"
      ></tr>
    </table>

    <!-- Empty State -->
    <div
      *ngIf="filteredAssociations.length === 0 && !isLoading"
      class="px-6 py-12 text-center text-slate-500"
    >
      <p class="text-lg font-medium">No state associations found</p>
      <p class="text-sm mt-1">Try adjusting your filter</p>
    </div>
  </div>
</div>